import { render, staticRenderFns } from "./basicInfo.vue?vue&type=template&id=d6753904&scoped=true"
import script from "./basicInfo.vue?vue&type=script&lang=js"
export * from "./basicInfo.vue?vue&type=script&lang=js"
import style0 from "./basicInfo.vue?vue&type=style&index=0&id=d6753904&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6753904",
  null
  
)

export default component.exports